import { render, staticRenderFns } from "./SelectGroupStudentMenu.vue?vue&type=template&id=18376e9c"
import script from "./SelectGroupStudentMenu.vue?vue&type=script&lang=js"
export * from "./SelectGroupStudentMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports